import { DriveDocument } from '@/api/types/drive'

export class FileSystemItem {
  constructor(public name: string, public s3Path: string) {}
  public isFile(): boolean {
    return false
  }
  public isDirectory(): boolean {
    return false
  }
}
export class File extends FileSystemItem {
  constructor(
    public name: string,
    public s3Path: string,
    public size: number,
    public lastModified: Date,
  ) {
    super(name, s3Path)
  }
  public isFile(): boolean {
    return true
  }
  public isDirectory(): boolean {
    return false
  }
}
export class Directory extends FileSystemItem {
  constructor(public name: string, public s3Path: string) {
    super(name, s3Path)
  }
  public isDirectory(): boolean {
    return true
  }
  public isFile(): boolean {
    return false
  }
}
export class FileState {
  constructor(
    public selectedDriveUuid: string,
    public drive: DriveDocument | null,
    public directories: Array<Directory>,
    public files: Array<File>,
    public path: string,
    public selectedPaths: Set<string>,
  ) {}
}

export type ShareLink = {
  drive_uuid: string
  expiry_timestamp?: number
  password_hash?: string
  paths: { path: Path }[]
  permissions: Permissions
  title?: string
}

export type Permissions = {
  list: boolean
  download: boolean
  upload: boolean
}

export type Path = {
  path: string
}

export type PathsWithNameAndPermissions = {
  title: string
  paths: Path[]
  permissions: Permissions
}
